<template>
  <div class="artisan-tab">
    <div class="artisan-tab-header">
      <div class="artisan-tab-bar" @click="leftScroll">
        <i class="el-icon-d-arrow-left"></i>
      </div>
      <div class="artisan-tab-item" ref="tabTitle">
        <div
          :class="item.isActive ? 'tab-item-active' : 'tab-item-inactive'"
          v-for="(item, index) in tabList"
          :key="index"
          @click="changeActvie(item)"
          v-focus="item.isActive"
        >
          <i v-if="item.icon" :class="item.icon"></i>
          {{ item.name }}
          <span
            v-if="item.closable"
            class="el-icon-close tab-item-close"
            @click="tabClose(item)"
          ></span>
        </div>
      </div>

      <div class="artisan-tab-bar" @click="rightScroll">
        <i class="el-icon-d-arrow-right"></i>
      </div>
      <div class="artisan-tab-bar" @click="dropClick('refresh')">
        <i class="el-icon-refresh"></i>
      </div>
      <el-dropdown @command="dropClick">
        <div class="artisan-tab-bar">
          <i class="el-icon-arrow-down"></i>
        </div>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="closeCurrent">
            <i class="el-icon-close"></i>关闭当前页
          </el-dropdown-item>
          <el-dropdown-item command="closeOther">
            <i class="el-icon-close"></i>关闭其他
          </el-dropdown-item>
          <el-dropdown-item command="closeAll">
            <i class="el-icon-close"></i>关闭所有
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <div class="artisan-tab-content">
      <div
        class="artisan-tab-pane"
        v-show="item.isActive"
        v-for="(item, index) in tabList"
        :key="index"
      >
        <transition name="el-zoom-in-center">
          <component :is="item.path" :query="item.query" :key="item.key">
          </component>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
export default {
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["tabList", "menus"]),
  },
  directives: {
    focus: {
      update: function (el, binding) {
        if (binding.value) {
          const val = el.offsetLeft + el.clientWidth;
          const max =
            el.parentElement.clientWidth + el.parentElement.scrollLeft;
          if (!(el.offsetLeft >= el.parentElement.scrollLeft && val <= max)) {
            el.parentElement.scrollLeft =
              el.offsetLeft - parseInt(el.parentElement.clientWidth / 2);
          }
        }
      },
    },
  },
  created() {
    this.setHomeTab({
      name: "工作台",
      url: "Home",
    });
  },
  methods: {
    ...mapMutations([
      "setHomeTab",
      "addTab",
      "activeTab",
      "refreshTab",
      "delTab",
      "delAllTab",
      "delOtherTab",
    ]),
    changeActvie(tab) {
      this.activeTab(tab.name);
    },
    tabClose(tab) {
      this.delTab(tab.name);
    },
    dropClick(command) {
      switch (command) {
        case "refresh":
          this.refreshTab();
          break;
        case "closeCurrent":
          this.delTab();
          break;
        case "closeOther":
          this.delOtherTab();
          break;
        case "closeAll":
          this.delAllTab();
          break;
      }
    },
    leftScroll() {
      this.$refs.tabTitle.scrollLeft -= 100;
    },
    rightScroll() {
      this.$refs.tabTitle.scrollLeft += 100;
    },
  },
};
</script>

<style>
</style>